import { useState, useEffect, useRef } from "react";
import { screens } from "tailwindcss/defaultTheme";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";

import logo from "../assets/images/logo.png";
import Divider from "../components/Divider";
import IconText from "../components/IconText";

const HeaderIntro = () => {
  const getAppRef = useRef(null);
  const [menuOpen, setMenOpen] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);
  const navRef = useRef(null);

  
  useEffect(() => {
    const navbar = navRef.current;
    const links = navbar.querySelector(".links");
    const buttonArrow = getAppRef.current.querySelector(".icon");
    // buttonArrow.classList.add("w-0");
    // if(buttonHovered) {

    //   buttonArrow.classList.add("w-auto");
    // }

    if (window.innerWidth < screens.lg) {
      if (menuOpen) {
        links.style.display = "flex";
      } else {
        setTimeout(() => {
          links.style.display = "none";
        }, 200);
      }
    }

  }, [menuOpen, buttonHovered]);

  const handleMouseEnter = () => {
    setButtonHovered(true);
  };

  const handleMouseLeave = () => {
    setButtonHovered(false);
  };
  
  const handleOpen = () => {
    setMenOpen(!menuOpen);
  };

  return (
    <>
      <header className="lg:w-[95%] max-w-[1400px] md:mx-auto h-fit xs:p-3 lg:px-6 md:bg-inherit text-[#686868] fixed top-0 left-0 bottom-0 right-0 z-10">
        <nav
          ref={navRef}
          className={`header-wrapper bg-white  rounded-md flex flex-row p-5 text-sm font-[500] justify-between items-center xs:flex-wrap lg:flex-nowrap shadow-[0_1px_32px_rgb(0_0_0_/_15%)] transition-all duration-200 overflow-hidden delay-150 ${
            menuOpen ? "max-h-96 scale-y-100" : "max-h-[69px]"
          }`}
        >
          <div className="logo shrink-0">
            <img src={logo} alt="" className="xs:w-[110px] lg:w-[120px]" />
          </div>
          <div
            className={`links flex flex-auto xs:justify-center lg:justify-between xs:flex-col overflow-hidden lg:flex-row xs:w-full xs:order-last lg:order-none transition-all duration-200`}
          >
            <ul className="nav-items flex items-center uppercase font-medium justify-center flex-auto xs:flex-col lg:flex-row xs:w-full lg:flex-initial">
              <li className="m-2">
                <Link to="/" className="hover:text-black duration-200  relative after:content-[''] after:block after:transition-all after:duration-300 after:border-black after:h-full after:border-b after:border-dotted after:w-full after:scale-x-0 hover:after:scale-x-100">Shop Healthy</Link>
              </li>
              <li className="m-2">
              <a href="" className={`hover:text-black duration-200  relative after:content-[''] after:block after:transition-all after:duration-300 after:border-black after:h-full after:border-b after:border-dotted after:w-full after:scale-0 hover:after:scale-100`}>
                  Explore the experiences
                </a>
              </li>
              <li className="m-2">
              <a href="" className={`hover:text-black duration-200  relative after:content-[''] after:block after:transition-all after:duration-300 after:border-black after:h-full after:border-b after:border-dotted after:w-full after:scale-0 hover:after:scale-100`}>
                  The Software
                </a>
              </li>
            </ul>
            <div className="button shrink-0 xs:m-2 lg:m-0 mb-0 flex justify-center">
              <button ref={getAppRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="uppercase relative bg-[#D45536] text-white rounded px-9 h-[38px] text-center flex items-center">
                <span>
                  Get the App
                </span>
                <span className={`icon transition-all duration-200 top-1/2 ${buttonHovered? 'opacity-100 ml-2' : 'opacity-0 -ml-3' }`}>
                  <IconText iconInfo={{Icon: HiArrowRight}}/>
                </span>
              </button>
            </div>
          </div>
          <div
            onClick={handleOpen}
            className="menu-bars w-9 h-9 flex flex-col justify-center p-1 lg:hidden cursor-pointer"
          >
            <span
              className={`border rounded-full border-black w-5/6 mb-1 relative transition-all duration-300 place-self-end ${menuOpen? 'translate-y-1/2 rotate-45 mb-0': ''}`}
            ></span>
            <span
              className={`border rounded-full border-black w-1/2 mb-1 place-self-end ${menuOpen? 'hidden' : 'block'}`}
            ></span>
            <span
              className={`border rounded-full border-black w-5/6 mb-1 relative transition-all duration-300 place-self-end ${menuOpen? '-translate-y-1/2 -rotate-45 mb-0': ''}`}
            ></span>
          </div>
          <div className="lg:hidden py-4 w-full">
            <Divider />
          </div>
        </nav>
      </header>
      <div className="xs:hidden lg:block w-full h-28"></div>
    </>
  );
};

export default HeaderIntro;
